import { Injectable } from '@angular/core';

export interface ComponentState {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class StatePersistenceService {

  constructor() { }

  saveState(componentKey: string, state: ComponentState, contextId?: string | number): void {
    try {
      const key = this.generateKey(componentKey, contextId);
      const stateString = JSON.stringify(state);
      sessionStorage.setItem(key, stateString);
    } catch (error) {
    }
  }

  loadState(componentKey: string, contextId?: string | number): ComponentState | null {
    try {
      const key = this.generateKey(componentKey, contextId);
      const stateString = sessionStorage.getItem(key);

      if (!stateString) {
        return null;
      }

      const state = JSON.parse(stateString);
      return this.validateState(state) ? state : null;
    } catch (error) {
      return null;
    }
  }

  clearState(componentKey: string, contextId?: string | number): void {
    try {
      const key = this.generateKey(componentKey, contextId);
      sessionStorage.removeItem(key);
    } catch (error) {
    }
  }

  clearAllStatesForComponent(componentKey: string): void {
    try {
      const keysToRemove: string[] = [];
      const prefix = `lms-state-${componentKey}`;

      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith(prefix)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(key => sessionStorage.removeItem(key));
    } catch (error) {
    }
  }

  clearAllStates(): void {
    try {
      const keysToRemove: string[] = [];
      const prefix = 'lms-state-';

      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith(prefix)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(key => sessionStorage.removeItem(key));
    } catch (error) {
    }
  }

  clearStatesForEntity(oldEntityId?: string | number): void {
    try {
      if (!oldEntityId) return;

      const keysToRemove: string[] = [];
      const suffix = `-${oldEntityId}`;

      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith('lms-state-') && key.endsWith(suffix)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(key => sessionStorage.removeItem(key));
    } catch (error) {
    }
  }

  hasState(componentKey: string, contextId?: string | number): boolean {
    try {
      const key = this.generateKey(componentKey, contextId);
      return sessionStorage.getItem(key) !== null;
    } catch (error) {
      return false;
    }
  }

  private generateKey(componentKey: string, contextId?: string | number): string {
    const baseKey = `lms-state-${componentKey}`;
    return contextId ? `${baseKey}-${contextId}` : baseKey;
  }

  private validateState(state: any): boolean {
    return state !== null && typeof state === 'object' && !Array.isArray(state);
  }

}
